<!-- IMPORTANT 
            form -> formGroup = Object created to hold structure 
            mat-<type>-stepper -> formArrayName = name of object in group holding groups of fields
            mat-step -> formGroupName = position in array
                     -> stepControl = code called to get the actual group in the array position
                input -> formControlName = name in inner group that controls this field 
                      -> #id markers can be used to map to @Input fields 
                
        -->
<form matForm [formGroup]='formGrouping' (ngSubmit)="sendSubmit($event)">
    @if( !!isSearchOpen() || !isWizardOpen ) {
    <mat-card>
        @if ( !isWizardOpen ) {
        <mat-card-header>
            <mat-card-title class="justified">
                <h2 class="mat-headline-3">
                    <p>
                        <markdown class='justified' [disableSanitizer]="true">{{appConfig?.info?.regInstructions}}
                        </markdown>
                    </p>
                </h2>
            </mat-card-title>
        </mat-card-header>
        }
        <mat-card-content>
            @if (!isWizardOpen ) {
            <div>
                @for( helpValue of appConfig?.info?.helpText; track $index) {
                <p>
                    <markdown class='justified' [disableSanitizer]="true">{{helpValue}}</markdown>
                </p>
                }
                <p>Email: <a [href]="appConfig?.info?.emailAdmissions">{{appConfig?.info?.emailAdmText ?? 'Admissions
                        Help'}}</a></p>
                <br />
                <p>
                    <markdown class='justified' [disableSanitizer]="true">{{appConfig?.info?.aupText}}</markdown>
                    <a href='/aup' target='aup' aria-label="Read the acceptable use policy, opens in a new window">Read
                        the
                        acceptable use policy</a>
                </p>

                @if (appConfig?.info?.policyUrl) {
                <br />
                <p>
                    <markdown class='justified' [disableSanitizer]="true">{{appConfig?.info?.diversityText}}</markdown>
                </p>
                <p>To review the full
                    university policy please <a [href]="appConfig?.info?.policyUrl">click here</a>.</p>
                }
                @if ( appConfig?.info?.emailResource ) {
                <br />
                <p>
                    If you are a student with a disability and you need assistance and guidance in completing your
                    application, please contact Disability Resource Center by Email: <a
                        [href]='appConfig?.info?.emailResource'>{{appConfig?.info?.emailResource.split(':')[1]}}</a> or
                    call <a
                        [href]='appConfig?.info?.phoneResource'>{{appConfig?.info?.phoneResource.split(':')[1]}}</a>.
                </p>
                }

            </div>
            @if ( !isSearchOpen() ) {
            <div>
                @if (_displaySearchButton) {
                <mat-divider></mat-divider>
                <div>
                    Applied before? Let's try and find your information.
                </div>
                }
                <mat-card-actions align='end' class="align-items-center">
                    @if (_displaySearchButton) {
                    <button type='button' (click)="openSearch()" mat-flat-button color="accent">Start
                        Search</button>
                    <div class="or-text"> - or - </div>
                    }
                    <button type="button" (click)="openWizard();reassignTabRole();" mat-flat-button color="accent">
                        Start Account Creation</button>
                </mat-card-actions>
            </div>
            }
            }
        </mat-card-content>

    </mat-card>
    } @else if (!!isWizardOpen) {
    <mat-card>
        <mat-card-content>
            <mat-stepper #registerWizard="matHorizontalStepper" linear='true' labelPosition='bottom'
                formArrayName="formArray" [orientation]='"horizontal"' (selectionChange)="onStepChange($event)"
                [class]="isVertical ? 'stepper-orientation stepper-orientation-vertical' : 'stepper-orientation stepper-orientation-horizontal'">
                <ng-template matStepperIcon="number" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="edit" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="error" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="done" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="steps[index].step" let-index="index">
                    {{index + 1}}
                </ng-template>
                <mat-step formGroupName='0' [stepControl]='page(0)' aria-label="About you">
                    @if ( isVertical ) {
                    <mutara-stepper-header [index]="0" [stepCount]="3" [stepLabel]="'Tell us about you'"
                        [nextStepLabel]="'Contact information'"></mutara-stepper-header>
                    }
                    <ng-template matStepLabel>Tell us about you</ng-template>
                    <div class="display-flex">
                        <mat-form-field required class="flex-1">
                            <mat-label>Legal First Name</mat-label>
                            <input matInput type='text' #firstname id='firstname' formControlName='firstname'
                                placeholder="ex. Terrence">
                        </mat-form-field>
                        <mat-form-field required class="flex-1">
                            <mat-label>Legal Last Name</mat-label>
                            <input matInput type='text' #lastname id='lastname' formControlName='lastname'
                                placeholder="ex. Jones">
                        </mat-form-field>
                        <mat-form-field class="flex-1">
                            <mat-label>Preferred Name</mat-label>
                            <input matInput type='text' #nickname formControlName='nickname' placeholder="ex. Terry"
                                [value]='firstname.value'>
                        </mat-form-field>
                    </div>

                    <mat-card-actions align="end">
                        <button mat-flat-button type='button'
                            (click)="closeSearch();closeWizard();registerWizard.reset()" color="accent">Cancel</button>
                        <button mat-flat-button type='button' matStepperNext aria-label="Proceed to Contact Information"
                            color="accent">Next</button>
                    </mat-card-actions>
                </mat-step>

                <mat-step formGroupName='1' [stepControl]='page(1)' aria-label="Contact info">
                    @if( isVertical) {
                    <mutara-stepper-header [index]="1" [stepCount]="3" [stepLabel]="'Contact Information'"
                        [nextStepLabel]="'Review and Submit'"></mutara-stepper-header>
                    }
                    <ng-template matStepLabel>Contact Information</ng-template>
                    <mutara-alert
                        secondaryText="The email you provide will be used to sign into this website. It must not be a pre-college school email and should be one you check regularly."></mutara-alert>
                    <div class="display-flex">
                        <mat-form-field required class="flex-1">
                            <mat-label>e-mail</mat-label>
                            <mat-hint>Used to login</mat-hint>
                            <input title='e-mail' matInput type='email' #email formControlName='email'
                                autocomplete="username">
                        </mat-form-field>
                        <mat-form-field #country required class="flex-1">
                            <mat-label>Phone Country</mat-label>
                            <mat-hint>Country of your phone number</mat-hint>
                            <mat-select [(value)]="phoneCountry">
                                @for ( option of countries; track option.value ) {
                                <mat-option [value]='option.value'>({{option.phone}})
                                    {{option.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field required class="flex-1">
                            <mat-label>Phone Number</mat-label>
                            <mat-hint>Cell preferred</mat-hint>
                            <input matInput type='tel' #phone formControlName='phone' placeholder="(123) 555-1212"
                                [showMaskTyped]='true' placeHolderCharacter=' ' [mask]="mask">
                        </mat-form-field>
                        <!-- Need to make this an actual checkbox extension -->
                        <div class="flex-full mat-mdc-form-field">
                            <mat-label class="small-text">SMS Mobile Communication</mat-label>
                            <mat-hint [class]="'sms-up micro-text'">{{appConfig?.info?.institution}} communicates using
                                SMS Mobile
                                messaging; do you consent to receive messages from
                                {{appConfig?.info?.institution}}?</mat-hint>
                            <mat-checkbox #sms formControlName='sms' class="flex-1">Send me text</mat-checkbox>
                        </div>
                    </div>

                    <mat-card-actions align='end'>
                        <button mat-flat-button type='button'
                            (click)="closeSearch();closeWizard();registerWizard.reset()" color="accent">Cancel</button>
                        <button mat-flat-button type='button' matStepperPrevious aria-label="Return to previous step"
                            color="accent">Back</button>
                        <button mat-flat-button type='button' matStepperNext aria-label="Proceed to Review and Password"
                            color="accent">Next</button>
                    </mat-card-actions>
                </mat-step>
                <mat-step formGroupName='2' [stepControl]='page(2)' aria-label="Review and Submit">
                    @if ( isVertical ) {
                    <mutara-stepper-header [index]="2" [stepCount]="3"
                        [stepLabel]="'Review and Submit'"></mutara-stepper-header>
                    }
                    <ng-template matStepLabel>Review and Submit</ng-template>
                    <h2 class="text-wrap mat-headline-3">After you click Submit, we will send a verification email
                        and/or text message to confirm your contact information.</h2>
                    <br>

                    <div class="display-flex">
                        <div class="flex-2 mutara-tb-pad">
                            <strong>Username: </strong>
                            <span>{{email.value}}</span>
                            <br>
                            <b>{{firstname.value}} {{lastname.value}} </b>
                            @if (nickname.value!='' && nickname.value != firstname.value ) { ({{nickname.value}}) }
                            <br>{{email.value}}
                            <br>{{prettyPhone(phone)}} {{sms.checked ? ' (Send Texts)' : ''}}

                        </div>
                        <div class="display-flex">
                            <div class="flex-full display-flex-vert">
                                <mat-form-field class="flex-1 mutara-lr-pad">
                                    <mat-label>Password</mat-label>
                                    <input matInput #password formControlName='password' placeholder="ex: bubbl3Gum!"
                                        [type]="hide ? 'password' : 'text'" maxlength="30"
                                        autocomplete="current-password">
                                    <mat-hint [class]="">{{passwordDescription}}</mat-hint>
                                    <!-- button type="button" mat-icon-button matIconSuffix (click)="hide = !hide"
                                    [attr.aria-label]="hide ? 'Show password' : 'Mask password'">&nbsp;
                                    <mat-icon color='primary'>{{hide ? 'visibility_off' :
                                        'visibility'}}</mat-icon>
                                </button -->
                                </mat-form-field>
                                <mat-form-field class="flex-1 mutara-lr-pad">
                                    <mat-label>Applicant Type</mat-label>
                                    <mat-select [(value)]='studentType' formControlName='studentType'>
                                        @for ( option of typeList; track option.value ) {
                                        <mat-option [value]='option.value'>{{option.label}}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                @if ( hasWaiver ) {
                                <mat-form-field class="flex-1 mutara-lr-pad">
                                    <mat-label>Fee Waiver Code</mat-label>
                                    <input title='waiver' matInput type='text' #waiver formControlName='waiver'>
                                    <mat-hint>Case sensitive fee waiver code provided by the recruiter at an event you
                                        attended</mat-hint>
                                </mat-form-field>
                                }
                            </div>
                        </div>
                        <br>
                        <mat-checkbox required #verify formControlName='verify' class="flex-full"
                            aria-label="Please confirm verification of the information by checking this box"
                            matTooltip="Verify information">
                            I verify the information above to be correct
                        </mat-checkbox>
                    </div>

                    <mat-card-actions class="flex-full" align='end'>
                        <button mat-flat-button type='button'
                            (click)="closeSearch();closeWizard();registerWizard.reset()" color="accent">Cancel</button>
                        <button mat-flat-button type='button' matStepperPrevious
                            aria-label="Return to Contact Information" color="accent">Back</button>
                        <button mat-flat-button type='submit' [disabled]="registrationPage?.invalid"
                            aria-label="Submit account creation" color="accent">Submit</button>
                    </mat-card-actions>

                </mat-step>
            </mat-stepper>
        </mat-card-content>
        @if( !!processing ) {
        <mat-progress-bar mode="indeterminate" class="mutara-progress-bar"></mat-progress-bar>
        }
        <mat-card-footer class='mutara-subtitle'>All communications with {{schoolName}} are strictly
            confidential</mat-card-footer>
    </mat-card>
    }
</form>